import type { CallMember } from '@/contexts/chat/scripts/hooks/useChatMediaCall/types';
import type { RoomUser } from '@/contexts/chat/scripts/hooks/useQuickVO/types';

export enum SubscribeStatus {
  DEFAULT = 0,
  SUBSCRIBEING = 1,
  SUBSCRIBE_SUCCESS = 2,
  SUBSCRIBE_FAIL = 3,
  SUBSCRIBE_CANCEL = 4,
}
export interface CallMemberItem extends CallMember {
  fixed: boolean;
  id: string;
  screenSharing: boolean;
  roomUser: RoomUser;
  subscribeStatus: SubscribeStatus;
}
